import React, { useState } from 'react';
import { FiBell, FiX } from 'react-icons/fi';
import Toggle from '../../../Toggle';
import { toast } from '../../../Toast';
import { EMAIL, TabProps } from './formSettingsData';

// Form settings › Notifications (spec 410:12432)
const Notifications: React.FC<TabProps> = ({ form, setForm }) => {
    const [typed, setTyped] = useState('');

    // typed or pasted, one or more addresses separated by commas, semicolons or spaces
    const add = () => {
        const list = typed.split(/[,;\s]+/).map(x => x.trim()).filter(x => x);
        if (list.length === 0) return;
        const bad = list.find(x => !EMAIL.test(x));
        if (bad) {
            toast.error(`${bad} isn’t an email address`);
            return;
        }
        setForm(f => ({ ...f, recipients: [...f.recipients, ...list.filter((x, i) => list.indexOf(x) === i && !f.recipients.some(r => r.toLowerCase() === x.toLowerCase()))] }));
        setTyped('');
    };

    const remove = (email: string) => setForm(f => ({ ...f, recipients: f.recipients.filter(x => x !== email) }));

    return <section className="card">
        <div className="section-title"><span className="icon-tile"><FiBell /></span><h2>Who gets told about new messages</h2></div>

        <div className="field">
            <label className="label" htmlFor="hub-fs-recipients">Send an email to</label>
            <div className="hub-fs-emails" onClick={e => e.currentTarget.querySelector('input')?.focus()}>
                {form.recipients.map(r => <span key={r} className="hub-fs-email">
                    {r}
                    <button type="button" aria-label={`Remove ${r}`} onClick={() => remove(r)}><FiX /></button>
                </span>)}
                <input id="hub-fs-recipients" value={typed} placeholder="Add another email…" onChange={e => setTyped(e.target.value)} onBlur={add}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(); }
                        if (e.key === 'Backspace' && !typed && form.recipients.length) remove(form.recipients[form.recipients.length - 1]);
                    }} />
            </div>
        </div>

        <div className="hub-fs-rows">
            <div className="setting-row">
                <div className="text"><div className="title">Also show in Investi notifications</div><div className="hint">The bell at the top of every page</div></div>
                <Toggle label="Also show in Investi notifications" checked={form.bell} onChange={bell => setForm(f => ({ ...f, bell }))} />
            </div>
            <div className="setting-row">
                <div className="text"><div className="title">Daily summary instead of one email per message</div><div className="hint">Sent at 8:00 am AWST</div></div>
                <Toggle label="Daily summary instead of one email per message" checked={form.dailySummary} onChange={dailySummary => setForm(f => ({ ...f, dailySummary }))} />
            </div>
        </div>
    </section>;
};

export default Notifications;
